import React from "react"
import { inject, observer } from "mobx-react"
import { Row, Col } from "react-styled-flexboxgrid"

import PlateNumber from "./PlateNumber"
import LicenseState from "./LicenseState"
import Spacer from "~/components/Spacer"
import TABLE_SIZES from "../Grid/outterTableSizesRow"

@inject((all) => ({
  isMobile: all.store.ui.isMobile,
}))
@observer
class PlateNumberAndLicenseState extends React.Component {
  render() {
    return (
      <Row>
        <Col lg={8} md={8} sm={8} xs={16}>
          <PlateNumber />
        </Col>
        <Col lg={8} md={8} sm={8} xs={16}>
          <LicenseState />
        </Col>
      </Row>
    )
  }
}

export default PlateNumberAndLicenseState

